"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useQuestionSelectionActions = require("../../hooks/questionnaire/useQuestionSelectionActions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const QuestionWithTextInput = _ref => {
  var _question$messageText;
  let {
    question,
    selections
  } = _ref;
  const [value, setValue] = _react.default.useState('');
  const selection = selections[0] || '';
  const {
    replaceSelection,
    removeSelection
  } = (0, _useQuestionSelectionActions.useQuestionSelectionActions)(question);
  const isHasAnError = inputValue => question.max && inputValue > question.max;
  const onChange = textValue => {
    setValue(textValue);
    if (!isHasAnError(textValue)) replaceSelection(textValue);else removeSelection(selection);
  };
  const hasAnError = isHasAnError(value);
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextInputWithLabel, {
    state: hasAnError && 'error',
    fieldWrapper: {
      label: (_question$messageText = question.messageText) !== null && _question$messageText !== void 0 ? _question$messageText : null,
      width: 'full',
      stateText: hasAnError && `We do not support more than "${question.max}", Please try another value`
    },
    textInput: {
      type: question.textInputType || 'text',
      value: value,
      onChange: e => onChange(e.target.value)
    },
    dataAttributes: {
      'data-test-id': 'text-input'
    }
  });
};
var _default = QuestionWithTextInput;
exports.default = _default;